import { YOUR_WEIR_HUB, YOUR_WEIR_LOGIN } from '../constants/links.constants'

export const logout = (isAccountDeleted?: boolean) => {
    sessionStorage.clear()
    localStorage.clear()
    window.location.replace(isAccountDeleted ? YOUR_WEIR_LOGIN : YOUR_WEIR_HUB)
}
